import logoBranca from "../assets/logo-branca.png";
import logoVerde from "../assets/logo-verde.png";
import type { Theme } from "../theme";
import { IconHome } from "../icons";
import { goToSystem, SYSTEMS } from "../integration";

type GateStatus = "checking" | "denied" | "error";

interface Props {
  status: GateStatus;
  /** Usuário atual (levado de volta ao Portal). */
  user: string | null;
  theme: Theme;
}

/**
 * Tela cheia do "portão de acesso" da Fase 2.
 * - "checking": verificação em andamento (não pisca o app).
 * - "denied": usuário sem acesso a este sistema.
 * - "error": falha ao consultar o Portal (rede/erro) — não libera.
 */
export default function AccessGate({ status, user, theme }: Props) {
  const logo = theme === "dark" ? logoBranca : logoVerde;

  if (status === "checking") {
    return (
      <div className="login">
        <main className="login-main" style={{ width: "100%" }}>
          <div className="login-form-wrap" style={{ textAlign: "center" }}>
            <img src={logo} alt="SERCAMP" className="login-mobile-logo" />
            <h1 className="login-title">Verificando acesso...</h1>
            <p className="login-sub">Aguarde enquanto confirmamos suas permissões.</p>
          </div>
        </main>
      </div>
    );
  }

  const title =
    status === "denied"
      ? "Você não tem acesso a este sistema"
      : "Não foi possível verificar o acesso";
  const message =
    status === "denied"
      ? "Fale com o Admin Supremo."
      : "Não conseguimos confirmar suas permissões com o Portal. Tente novamente em instantes ou volte ao Portal.";

  return (
    <div className="login">
      <main className="login-main" style={{ width: "100%" }}>
        <div className="login-form-wrap" style={{ textAlign: "center" }}>
          <img src={logo} alt="SERCAMP" className="login-mobile-logo" />
          <h1 className="login-title">{title}</h1>
          <p className="login-sub">{message}</p>
          <button
            type="button"
            className="btn-primary login-btn"
            onClick={() => goToSystem(SYSTEMS.portal, user)}
            style={{ marginTop: 16, display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            <IconHome size={18} />
            Voltar ao Portal
          </button>
        </div>
      </main>
    </div>
  );
}
